import React, {useEffect} from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import PropTypes from "prop-types";
import {Calendar} from "primereact/calendar";
import { SLQ_USER_STATUSES } from "../../../../constants/actionTypes";
import {connect} from "react-redux";
import agent from "../../../../agent";
import {Dropdown} from "primereact/dropdown";

const mapStateToProps = (state) => ({
    statuses: state.slqUser?.statuses,
});

const mapDispatchToProps = dispatch => ({
    onStatuses: (payload) => {
        dispatch({ type: SLQ_USER_STATUSES, payload });
    },
});
/**
 * Simple filter form used by "Акт сверки АВР (Юр лица)".
 * Props:
 * - q: current query string
 * - setQ: setter function for query
 * - onSubmit: submit handler (e) => { ... }
 * - onClear: clear/reset handler (e) => { ... }
 */
const AvrJurFilter = ({ filterParam, setFilterParam, onSubmit, onClear, statuses, onStatuses }) => {

    useEffect(() => {
        onStatuses(agent.SlqUser.getStatuses());
        // Fetch statuses only once on mount to avoid infinite re-renders
    }, []);

    return (
        <form onSubmit={onSubmit}>
            <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-6 p-md-3">
                    <label htmlFor="user">Телефон/ФИО/БИН/Наименование ЮР лица</label>
                    <InputText
                        id="user"
                        name="q"
                        value={filterParam.q || ""}
                        onChange={(e) => setFilterParam({ ...filterParam, q: e.target.value })}
                    />
                </div>
                <div className="p-field p-col-6 p-md-3">
                    <label htmlFor="avrNum">Номер АВР</label>
                    <InputText
                        id="avrNum"
                        name="avrNum"
                        value={filterParam.avrNum || ""}
                        onChange={(e) => setFilterParam({ ...filterParam, avrNum: e.target.value })}/>
                </div>
                <div className="p-field p-col-6 p-md-3">
                    <label htmlFor="statusId">Статус АВР</label>
                    <Dropdown
                        id="statusId"
                        name="statusId"
                        value={ filterParam.statusId }
                        options={statuses}
                        optionLabel="name"
                        optionValue="id"
                        placeholder="Статус АВР"
                        showClear
                        onChange={(e) => setFilterParam({ ...filterParam, statusId: e.value })}
                    />
                </div>
            </div>
                <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-6 p-md-3">
                    <label htmlFor="startDate">Дата начала</label>
                    <Calendar id="startDate" value={filterParam.startDate}
                              name="startDate"
                              onChange={(e) => setFilterParam({ ...filterParam, startDate: e.value })}
                              locale="ru"
                              showIcon
                              showButtonBar
                              onClearButtonClick={() => setFilterParam({ ...filterParam, startDate: null })}
                    />
                </div>
                <div className="p-field p-col-6 p-md-3">
                    <label htmlFor="endDate">Дата конца</label>
                    <Calendar id="endDate" value={filterParam.endDate}
                              name="endDate"
                              onChange={(e) => setFilterParam({ ...filterParam, endDate: e.value })}
                              locale="ru"
                              showIcon
                              showButtonBar
                              onClearButtonClick={() => setFilterParam({ ...filterParam, endDate: null })}
                    />
                </div>
            </div>
            <div className="p-grid p-justify-end">
                <div className="p-mr-2">
                    <Button type="submit" label="Найти" />
                </div>
                <div className="p-mr-2">
                    <Button className="p-button-warning" label="Сбросить" onClick={onClear} />
                </div>
            </div>
        </form>
    );
};

AvrJurFilter.propTypes = {
    filterParam: PropTypes.object.isRequired,
    setFilterParam: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AvrJurFilter);